import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const bulkImportApi = createApi({
  reducerPath: "bulkImportApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    bulkImport: build.mutation({
      query: ({ entityType, records }) => ({
        url: "/bulk-import",
        method: "POST",
        body: { entityType, records },
      }),
    }),
  }),
});

export const { useBulkImportMutation } = bulkImportApi;
